<template>
  <div>
    <top-bar :backto="'/admin/'" :back="false" fullscreen="true"/>
    <div style="margin-top:60px">
      <div class="w3-margin-bottom">
        <div class="w3-row-padding">
          <div class="w3-col l12">

            <div class="w3-row w3-small w3-margin-bottom">
              <div class="w3-col l10 w3-margin-top">
                <div class="w3-white w3-padding">
                  <span>Cliente</span><br/>
                  <span><b>
                    {{termo}}&nbsp;
                  </b></span>
                </div>
              </div>
              <div class="w3-col l2 w3-margin-top m-margin w3-hide-small" v-show="verificarPDV(1)">
                  <button class="w3-button w3-round primary w3-block " @click="modalPagamento = true">
                      <i class="fa fa-dollar"></i> <br>
                      Enviar Pagamento
                  </button>
              </div>
              <div class="w3-col l1 w3-margin-top w3-hide-large w3-hide-medium" v-show="verificarPDV(1)">
                <button class="w3-button w3-round primary w3-block" @click="modalPagamento = true" style="font-size: 14px;padding: 16px">
                    <b>ENVIAR PAGAMENTO</b>
                </button>
              </div>
            </div>

            <busca-pdv :comanda="comanda" @atualizarComanda="buscarComanda" :visivel="true"/>

            <div class="w3-white w3-round container-pdv">
              <div class="w3-blue-gray w3-center w3-text-white w3-small" style="padding: 6px"><b>Minhas Transações</b></div>
              <table class="w3-table w3-bordered w3-small w3-centered">
                <thead class="w3-hide-small">
                  <tr class="primary">
                    <th class="w3-left-align" style="width: 10%;">Data</th>
                    <th class="w3-left-align" style="width: 50%;">Produto</th>
                    <th class="w3-hide-small" style="width: 10%;">Valor</th>
                    <th style="width: 10%;">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="pointer" v-for="p in comanda.itens" :class="{'pagamento' : p.produto.tipo === '2'}" @click="update(p)">
                    <td class="w3-left-align">{{p.produto.dt_item}}</td>
                    <td class="w3-left-align">
                      <span v-show="p.produto.tipo === '1'"><b>{{p.quantidade | qtd}}x</b>
                          {{p.produto.nome_produto}}
                          <span v-show="p.produto.principal === '0'"><b>{{' - ' + p.produto.nome_tabela}}</b></span>
                      </span>
                      <span v-show="p.produto.tipo === '2'">
                          Pagamento <b v-show="p.produto.status_pagamento === '0'">(Pendente)</b>
                          <span v-show="p.produto.observacao">- {{p.produto.observacao}}</span>
                      </span>
                    </td>
                    <td class="w3-hide-small"><span v-show="p.produto.tipo === '1'">R$ {{p.produto.valor | valor}}</span></td>
                    <td>R$ {{p.produto.valor_total | valor}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Componentes-->
    <detalhes-produto @atualizarProduto="atualizarProduto" @removerProduto="removerProduto"/>

      <div class="w3-modal" :class="{'show':modalPagamento}">
          <div class="w3-modal-content">
              <div class="top-bar primary w3-small">
                  <button class="w3-button" style="margin: 6px" @click="modalPagamento = false">
                      Cancelar
                  </button>
                  <button class="w3-button w3-right" style="margin: 6px" @click="inserirPagamento">
                      Enviar Pagamento
                  </button>
              </div>
              <div class="w3-row-padding w3-small">
                  <div class="w3-col m12">
                      <h6 class="w3-center w3-padding-16"><b>ENVIAR PAGAMENTO</b></h6>
                      <div style="margin-bottom: 32px">
                          <div class="w3-row">
                              <div class="w3-col m12 w3-margin-top">
                                  <label><b>Pagamentos</b></label>
                                  <select class="w3-select w3-white w3-border" v-model="dadosPagamento.forma_pagamento">
                                      <option value="0">Selecione uma forma de pagamento</option>
                                      <option :value="f.id_pagamento" v-for="f in formas_pagamento">{{f.nome_pagamento}}</option>
                                  </select>
                              </div>
                              <div class="w3-col m12 w3-margin-top">
                                  <label><b>Valor</b></label>
                                  <money v-model="dadosPagamento.valor_pagamento" v-bind="money" class="w3-input w3-border"
                                         @keyup.enter.native="incluirPagamento"/>
                              </div>
                              <div class="w3-col m12 w3-margin-top">
                                  <label><b>Observações</b></label>
                                  <textarea class="w3-input w3-border" v-model="dadosPagamento.obs_pagamento" placeholder="Observações sobre o pagamento"></textarea>
                              </div>
                              <div class="w3-col m12 w3-margin-top">
                                  <button class="w3-button primary w3-block w3-round" @click="inserirPagamento">Enviar Pagamento</button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import DetalhesProduto from "./DetalhesProduto"
  import BuscaPdv from "./BuscaPDV"
  import {Money} from 'v-money'

  export default {
    components: {TopBar, DetalhesProduto, BuscaPdv, Money},
    name: "pdv",

    data() {
      return {
        token: '',
        formas_pagamento: [],
        modal: 0,
        modalVenda: false,
        modalPagamento: false,
        modalImprimir: false,
        modalFecharCaixa: false,
        modalOpenCaixa: false,
        comanda: [],
        item: null,
        totalComanda: 0.0,
        menuMais: true,
        produtoEditar: {},

        termo: '',

        money: {
          decimal: '.',
          thousands: '',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },

        caixaValor: 0,
        caixaPagamento: 1,
        caixa: {
          status: 2,
          pagamentos: []
        },

        dadosPagamento: {
          obs_pagamento: "",
          forma_pagamento: 0,
          valor_pagamento: 0
        }
      }
    },

    methods: {
      buscarComanda() {
        this.totalComanda = '0.00';

        let url = base_url + 'transacoes/produtos/' ;
        let id = this.$route.params.id;
        if (id) {
          url += id + '/';
        }

        openLoading("Buscando dados");
        this.$http.get(url + this.token)
          .then(response => {
            this.comanda = response.data;
            this.termo = this.comanda.nome;

            //console.log(response);
            this.totalizar();
            closeLoading();

          }, res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      buscarFormasPagamento() {
        this.$http.get(base_url + 'formas-pagamentos/' + this.token)
          .then(response => {
            this.formas_pagamento = response.data;
            closeLoading();

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      totalizar() {
        this.totalComanda = 0.0;
        this.comanda.itens.forEach((obj) => {
          this.totalComanda += parseFloat(obj.produto.valor_total);
        });
      },

      update(p) {
        if (this.verificarPDV(1) && p.produto.tipo === '1') {
          this.produtoEditar = p;
          this.$emit('editarProduto', p);
        }
      },

      atualizarProduto(p, edicao) {
        if (edicao) {
          let transacao = {
            transacao: {
              id_transacao_item: this.produtoEditar.produto.id_transacao_item
            }
          };

          openLoading("Editando as informações");
          let base = "transacoes/produto/editar/" + this.token;
          Object.assign(p, transacao);

          this.$http.post(base_url + base, p, {emulateJSON: true})
            .then(res => {
              closeLoading();
              this.buscarComanda();

            }, res => {
              console.log(res);
              closeLoading();
              openModalMsg(res.data.result, res.data.msg);
            });
        }
      },

      removerProduto() {
        let dados = {
          id_transacao_item: this.produtoEditar.produto.id_transacao_item
        };

        openLoading("Removendo as informações");
        this.$http.post(base_url + "transacoes/produto/remover/" + this.token, dados, {emulateJSON: true})
          .then(res => {
            closeLoading();
            this.buscarComanda();
            //console.log(res);

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      verificarPDV(status) {
        return parseInt(this.comanda.status) === status;
      },

      inserirPagamento() {
        if (this.dadosPagamento.forma_pagamento === 0) {
          openModalMsg("Atenção!", "Selecione uma forma de pagamento.");
          return;
        }

        if (this.dadosPagamento.valor_pagamento <= 0) {
          openModalMsg("Atenção!", "Informe um valor válido para o pagamento.");
          return;
        }

        let url = base_url + 'transacoes/inserir-pagamento/' ;
        openLoading("Enviando Pagamento");

        this.dadosPagamento.id_transacao = this.comanda.id_transacao;
        this.$http.post(url + this.token, this.dadosPagamento, {emulateJSON: true})
          .then(response => {
            closeLoading();

            if (response.data.result && response.data.result  === 'success') {
              this.buscarComanda();
              this.modalPagamento = false;
            }

          }, res => {
            closeLoading();
            console.log(res);
            openModalMsg(res.data.result, res.data.msg);
          });

      },

      inicializar() {
        window.scrollTo(0, 0);

        this.comanda = [];
        this.item = null;
        this.totalComanda = 0.0;
        this.menuMais = true;
        this.produtoEditar = {};
        this.termo = '';

        if (this.formas_pagamento.length === 0) {
          this.buscarFormasPagamento();
        }

        this.buscarComanda();

      }
    },

    mounted: function () {
      this.token = localStorage.getItem('key');
      this.inicializar();

      document.addEventListener('keydown', (event => {
        if (event.defaultPrevented) {
          return;
        }

        let key = event.key || event.keyCode;

        if (event.ctrlKey && key === 'q') {
          focarElement('inputCodigoProduto');
          event.preventDefault();
          event.stopPropagation();
        }

        if (event.ctrlKey && key === 'o') {
          this.$emit('abrirPedido', this.comanda);
          event.preventDefault();
          event.stopPropagation();
        }

        if (event.ctrlKey && key === 'i') {
          this.$emit('selCadastroVendaRapida');
          event.preventDefault();
          event.stopPropagation();
        }

      }));
    },

    filters: {
      valor(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(2);
        }
      },

      qtd(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed();
        }
      },

      medida(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(3) + " kg";
        }
      }
    }

  }
</script>

<style scoped>
  .pagamento {
    background-color: rgba(0, 163, 119,0.1)
  }
  .w3-btn:hover {
    box-shadow: none;
  }
  .container-pdv {
      position: absolute; left: 16px; right: 16px; bottom: 16px; top: 250px; z-index: 1;overflow: auto
  }

  @media all and (max-width: 993px) {
      .container-pdv {
          position: static;
          overflow: unset;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/pdv/PDV.vue